module.exports = "./img/adb6b7eaeb50f223a2023d923563a3f2.png";